import BuildingServices from "@/components/views/Services/Building";
import PaintingServices from "@/components/views/Services/Painting";
import ElectricalServices from "@/components/views/Services/Electrical";
import Landscaping from "@/components/views/Services/Landscaping";
import Plumbing from "@/components/views/Services/Plumbing";
import Tilling from "@/components/views/Services/Tilling";
import SwimmingPool from "@/components/views/Services/Swimmingpool";
import Aluminum from "@/components/views/Services/Aluminum";
import Carpentry from "@/components/views/Services/Carpentry";
import Fabrication from "@/components/views/Services/Fabrication";
import HouseholdFittings from "@/components/views/Services/HouseholdFittings";
import Architectural from "@/components/views/Services/Architectural";
import Ceiling from "@/components/views/Services/Ceiling";
import Renovations from "@/components/views/Services/Renovations";
import StoneCladding from "@/components/views/Services/StoneCladding";

export default [
  {
    path: "/services",
    alias: "/services/building",
    name: "services",
    component: BuildingServices
  },
  {
    path: "/services/painting",
    name: "painting",
    component: PaintingServices
  },
  {
    path: "/services/electrical",
    name: "electrical",
    component: ElectricalServices
  },
  {
    path: "/services/landscaping",
    name: "landscaping",
    component: Landscaping
  },
  {
    path: "/services/plumbing",
    name: "plumbing",
    component: Plumbing
  },
  {
    path: "/services/tilling",
    name: "tilling",
    component: Tilling
  },
  {
    path: "/services/swimmingpool",
    name: "swimmingpool",
    component: SwimmingPool
  },
  {
    path: "/services/aluminum",
    name: "aluminum",
    component: Aluminum
  },
  {
    path: "/services/carpentry",
    name: "aluminum",
    component: Carpentry
  },
  {
    path: "/services/fabrication",
    name: "fabrication",
    component: Fabrication
  },
  {
    path: "/services/householdfittings",
    name: "HouseholdFitting",
    component: HouseholdFittings
  },
  {
    path: "/services/architectural",
    name: "architectural",
    component: Architectural
  },
  {
    path: "/services/ceilingdesign",
    name: "Ceiling",
    component: Ceiling
  },
  {
    path: "/services/renovations",
    name: "renovations",
    component: Renovations
  },
  {
    path: "/services/stonecladding",
    name: "StoneCladding",
    component: StoneCladding
  }
];
